
const summarizedFlow = false

export const DLQI_OPTIONS = {
  CHILD: [
    {
      key: 'coceira',
      name: 'Ao longo da semana passada, quanto seu filho tem estado se coçando e se arranhando?',
      required: summarizedFlow,
    },
    {
      key: 'humor',
      name: 'Ao longo da semana passada, como tem estado o humor da criança?',
      options: [
        { text: 'Chorando sempre', value: 3 },
        { text: 'Extremamente difícil', value: 2 },
        { text: 'Muito irritável', value: 1 },
        { text: 'Feliz', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'problema_dormir',
      name: 'Ao longo da semana passada, aproximadamente quanto tempo em média levou para conseguir que seu filho fosse dormir a cada noite?',
      options: [
        { text: 'Mais de 2 horas', value: 3 },
        { text: '1 - 2 horas', value: 2 },
        { text: '15 minutos - 1 hora', value: 1 },
        { text: '0-15 minutos', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'problema_tempo_sono',
      name: 'Ao longo da semana passada, quanto tempo, em média, que o sono de seu filho foi perturbado a cada noite?',
      options: [
        { text: '5 horas ou mais', value: 3 },
        { text: '3 - 4 horas', value: 2 },
        { text: '1 - 2 horas', value: 1 },
        { text: 'Menos de 1 hora', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'dificuldade_esportes',
      name: 'Ao longo da semana passada, o eczema de seu filho interferiu com as atividades de brincar ou nadar?',
      required: summarizedFlow,
    },
    {
      key: 'atividade_social',
      name: 'Ao longo da semana passada, o eczema de seu filho interferiu com a participação de seu filho ou na apreciação de outras atividades familiares?',
      required: summarizedFlow,
    },
    {
      key: 'problema_refeicoes',
      name: 'Ao longo da semana passada, houve problemas com seu filho em na hora das refeições por causa do eczema?',
      required: summarizedFlow,
    },
    {
      key: 'problema_tratamento',
      name: 'Ao longo da semana passada, houve problemas com seu filho por causa do tratamento?',
      required: summarizedFlow,
    },
    {
      key: 'problema_roupas',
      name: 'Ao longo da semana passada, o eczema de seu filho significava que vestir-se e despir-se era desconfortável?',
      required: summarizedFlow,
    },
    {
      key: 'problema_banho',
      name: 'Ao longo da semana passada, quanto seu filho com eczema teve problemas na hora do banho?	',
      required: summarizedFlow,
    },
  ],

  MINOR: [
    {
      key: 'pele_afetada',
      name: 'Sua pele tem apresentado coceira, sensibilidade ou dor?',
      required: summarizedFlow,
    },
    {
      key: 'constrangimento',
      name: 'Você sentiu-se constrangio ou inhibido, chateado ou triste por causa de sua pele?',
      required: summarizedFlow,
    },
    {
      key: 'problema_relacao_parceiro_amigos_parentes',
      name: 'Sua pele tem afetado suas amizades?',
      required: summarizedFlow,
    },
    {
      key: 'interferencia_roupa',
      name: 'Você mudou a sua maneira de vestir por causa da sua pele?',
      required: summarizedFlow,
    },
    {
      key: 'atividade_social_lazer_afetado',
      name: 'Sua pele tem atrapalhado as suas atividades de lazer em geral?',
      required: summarizedFlow,
    },
    {
      key: 'dificuldade_esportes',
      name: 'Você evitou nadar ou praticar outros esportes por causa dos seus problemas de pele?',
      required: summarizedFlow,
    },
    {
      key: 'impedimento_trabalho_estudo_atual',
      name: 'Era período escolar? Se era: o quanto seu problema de pele interferiu em suas atividades escolares?',
      options: [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada / Não era período escolar', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'intereferencia_atividades_passeios',
      name: 'Era período de férias? Se era: o quanto seu problema de pele interferiu no aproveitamento de suas férias',
      options: [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada / Não era férias', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'bullying',
      name: 'Você teve problemas com pessoas dizendo nomes, caçoando, intimidando, fazendo perguntas ou evitando você?',
      required: summarizedFlow,
    },
    {
      key: 'problema_sono',
      name: 'Seu sono foi afetado por causa de seu problema de pele?',
      required: summarizedFlow,
    },
    {
      key: 'problema_tratamento_dermatologico',
      name: 'Seu tratamento dermatológico foi problemático?',
      required: summarizedFlow,
    },
  ],

  ADULT: [
    {
      key: 'pele_afetada',
      name: 'O quanto sua pele foi afetada durante a semana que passou por causa de coceira, inflamação, dor ou queimação?',
      required: summarizedFlow,
    },
    {
      key: 'constrangimento',
      name: 'Quanto constrangimento ou outro tipo de limitação foi causado por sua pele durante a semana que passou?',
      required: summarizedFlow,
    },
    {
      key: 'intereferencia_atividades_passeios',
      name: 'O quanto sua pele interferiu nas suas atividades de compras ou passeios, em casa ou em locais públicos, durante a semana que passou?',
      required: summarizedFlow,
    },
    {
      key: 'interferencia_roupa',
      name: 'Até que ponto sua pele interferiu na semana que passou com relação às roupas que você normalmente usa?',
      required: summarizedFlow,
    },
    {
      key: 'atividade_social_lazer_afetado',
      name: 'O quanto sua pele afetou qualquer uma das suas atividades sociais ou de lazer na semana que passou?',
      required: summarizedFlow,
    },

    {
      key: 'dificuldade_esportes',
      name: 'Quão difícil foi para você praticar esportes durante a semana que passou?',
      required: summarizedFlow,
    },
    {
      key: 'impedimento_trabalho_estudo_atual',
      name: 'Sua pele impediu que você fosse trabalhar ou estudar durante a semana que passou?',
      options: [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'impedimento_trabalho_estudo_passado',
      name: 'Em caso negativo, sua pele já foi problema para você no trabalho ou na vida escolar?',
      options: [
        { text: 'Realmente muito', value: 3 },
        { text: 'Bastante', value: 2 },
        { text: 'Um pouco', value: 1 },
        { text: 'Nada', value: 0 },
      ],
      required: summarizedFlow,
    },
    {
      key: 'problema_relacao_parceiro_amigos_parentes',
      name: 'Quão problemática se tornou sua relação com o(a) parceiro(a), amigos próximos ou parentes, por causa de sua pele?',
      required: summarizedFlow,
    },
    {
      key: 'dificuldade_vida_sexual',
      name: 'Até que ponto sua pele criou dificuldades na sua vida sexual na semana que passou?',
      required: summarizedFlow,
    },
    {
      key: 'problema_tratamento_dermatologico',
      name: 'Até que ponto seu tratamento dermatológico criou problemas para você durante a semana que passou?',
      required: summarizedFlow,
    },
  ],
}
